import type Client from '../client'
import PaginatedResponse from '../paginated-response'
import type {
  ErrorAble,
  RequestItemBag,
  SupplierBookingCodeContainer,
  SupplierBookingCodeContainerParameters,
  SupplierBookingCodeContainerResponse,
} from '@/api'

export default class SupplierContainer {
  constructor(private client: Client) {}

  async create(
    data: SupplierBookingCodeContainerParameters,
  ): Promise<ErrorAble<SupplierBookingCodeContainerResponse>> {
    return this.client.post(`csv-container`, {
      data,
    })
  }

  async update(
    id: number,
    data: SupplierBookingCodeContainerParameters,
  ): Promise<ErrorAble<SupplierBookingCodeContainerResponse>> {
    return this.client.put(`csv-container/${id}`, {
      data,
    })
  }

  async destroy(
    id: number,
  ): Promise<ErrorAble<SupplierBookingCodeContainerResponse>> {
    return this.client.delete(`csv-container/${id}`)
  }

  async list(
    page: number,
    query: RequestItemBag = {},
  ): Promise<PaginatedResponse<SupplierBookingCodeContainer>> {
    return new PaginatedResponse(
      await this.client.get('csv-container', {
        query: { ...query, page },
      }),
    )
  }
}
